import React from "react";
import BlogCard from "./BlogCard";
import blogData from "../data/blogData";
import "./BlogList.css";

const BlogSection = () => {
  return (
    <section className="blog-section" aria-labelledby="blog-heading">
      <header className="blog-header">
        <h2 id="blog-heading" className="blog-heading">
          Latest Blogs
        </h2>
        <p className="blog-subtitle">
          Insights, trends, and expert perspectives from the IQApex Labs team
        </p>
      </header>

      <div className="blog-grid">
        {blogData.map((blog, i) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>
    </section>
  );
};

export default BlogSection;
